/* eslint no-proto: 0 */

const errorsText = {
    pluginNotInstalled: 'Не подключен модуль для работы с cades plugin',
    pluginNotAvailable: 'КриптоПРО ЭЦП Browser Plug-In недоступен',
    certNotValid: message => `Ошибка при проверке сертификата: ${message}`,
    getCertProp: message => `Ошибка при обращении к свойству сертификата: ${message}`,
    exportCert: message => `Ошибка при экспорте сертификата: ${message}`,
    getCertAlgorithm: message => `Ошибка при получении алгоритма: ${message}`,
    getCertInfo: message => `Ошибка при извлечении данных из сертификата: ${message}`,
    openStore: message => `Ошибка при открытии хранилища: ${message}`,
    getCertList: message => `Ошибка получения списка сертификатов: ${message}`,
    emptyCertList: 'Нет доступных сертификатов',
    processingCertList: message => `Ошибка обработки сертификатов: ${message}`,
    thumbprintNotSpecified: 'Хэш не указан',
    certNotFound: hash => `Сертификат с хэшем: "${hash}" не найден`,
    getCertForHash: hash => `Не удалось получить сертификат по хэшу: ${hash}`,
    installSignData: message => `Ошибка при установке данных подписи: ${message}`,
    installHashData: message => `Ошибка при задании hash'а данных: ${message}`,
    installSignSettings: message => `Не удалось установить настройки для подписи: ${message}`,
    createSign: message => `Не удалось создать подпись: ${message}`,
};

export class PluginNotInstalledError extends Error {
    constructor() {
        super(errorsText.pluginNotInstalled);

        this.name = 'PluginNotInstalledError';
        this.constructor = PluginNotInstalledError;
        this.__proto__ = PluginNotInstalledError.prototype;
    }
}

export class PluginNotAvailableError extends Error {
    constructor() {
        super(errorsText.pluginNotAvailable);

        this.name = 'PluginNotAvailableError';
        this.constructor = PluginNotAvailableError;
        this.__proto__ = PluginNotAvailableError.prototype;
    }
}

export class CertificateNotValidError extends Error {
    constructor(message) {
        super(errorsText.certNotValid(message));

        this.name = 'CertificateNotValidError';
        this.constructor = CertificateNotValidError;
        this.__proto__ = CertificateNotValidError.prototype;
    }
}

export class GetCertificatePropError extends Error {
    constructor(message) {
        super(errorsText.getCertProp(message));

        this.name = 'GetCertificatePropError';
        this.constructor = GetCertificatePropError;
        this.__proto__ = GetCertificatePropError.prototype;
    }
}

export class ExportCertificateError extends Error {
    constructor(message) {
        super(errorsText.exportCert(message));

        this.name = 'ExportCertificateError';
        this.constructor = ExportCertificateError;
        this.__proto__ = ExportCertificateError.prototype;
    }
}

export class GetCertificateAlgorithmError extends Error {
    constructor(message) {
        super(errorsText.getCertAlgorithm(message));

        this.name = 'GetCertificateAlgorithmError';
        this.constructor = GetCertificateAlgorithmError;
        this.__proto__ = GetCertificateAlgorithmError.prototype;
    }
}

export class GetCertificateInfoError extends Error {
    constructor(message) {
        super(errorsText.getCertInfo(message));

        this.name = 'GetCertificateInfoError';
        this.constructor = GetCertificateInfoError;
        this.__proto__ = GetCertificateInfoError.prototype;
    }
}

export class OpenStoreError extends Error {
    constructor(message) {
        super(errorsText.openStore(message));

        this.name = 'OpenStoreError';
        this.constructor = OpenStoreError;
        this.__proto__ = OpenStoreError.prototype;
    }
}

export class GetCertificateListError extends Error {
    constructor(message) {
        super(errorsText.getCertList(message));

        this.name = 'GetCertificateListError';
        this.constructor = GetCertificateListError;
        this.__proto__ = GetCertificateListError.prototype;
    }
}

export class EmptyCertificateListError extends Error {
    constructor() {
        super(errorsText.emptyCertList);

        this.name = 'EmptyCertificateListError';
        this.constructor = EmptyCertificateListError;
        this.__proto__ = EmptyCertificateListError.prototype;
    }
}

export class ProcessingCertificateListError extends Error {
    constructor(message) {
        super(errorsText.processingCertList(message));

        this.name = 'ProcessingCertificateListError';
        this.constructor = ProcessingCertificateListError;
        this.__proto__ = ProcessingCertificateListError.prototype;
    }
}

export class ThumbprintNotSpecifiedError extends Error {
    constructor() {
        super(errorsText.thumbprintNotSpecified);

        this.name = 'ThumbprintNotSpecifiedError';
        this.constructor = ThumbprintNotSpecifiedError;
        this.__proto__ = ThumbprintNotSpecifiedError.prototype;
    }
}

export class CertificateNotFoundError extends Error {
    constructor(hash) {
        super(errorsText.certNotFound(hash));

        this.name = 'CertificateNotFoundError';
        this.constructor = CertificateNotFoundError;
        this.__proto__ = CertificateNotFoundError.prototype;
    }
}

export class GetCertificateForHashError extends Error {
    constructor(hash) {
        super(errorsText.getCertForHash(hash));

        this.name = 'GetCertificateForHashError';
        this.constructor = GetCertificateForHashError;
        this.__proto__ = GetCertificateForHashError.prototype;
    }
}

export class InstallSignDataError extends Error {
    constructor(message) {
        super(errorsText.installSignData(message));

        this.name = 'InstallSignDataError';
        this.constructor = InstallSignDataError;
        this.__proto__ = InstallSignDataError.prototype;
    }
}

export class InstallHashDataError extends Error {
    constructor(message) {
        super(errorsText.installHashData(message));

        this.name = 'InstallHashDataError';
        this.constructor = InstallHashDataError;
        this.__proto__ = InstallHashDataError.prototype;
    }
}

export class InstallSignSettingsError extends Error {
    constructor(message) {
        super(errorsText.installSignSettings(message));

        this.name = 'InstallSignSettingsError';
        this.constructor = InstallSignSettingsError;
        this.__proto__ = InstallSignSettingsError.prototype;
    }
}

export class CreateSignError extends Error {
    constructor(message) {
        super(errorsText.createSign(message));

        this.name = 'CreateSignError';
        this.constructor = CreateSignError;
        this.__proto__ = CreateSignError.prototype;
    }
}
